"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const qs_1 = __importDefault(require("qs"));
const interceptors_1 = require("./interceptors");
const sendRequestFactory = (axiosApi) => {
    return (path, axiosRequestConfig) => {
        const { data, method, options } = axiosRequestConfig;
        const mergedOptions = Object.assign({ data,
            method, paramsSerializer(params) {
                return qs_1.default.stringify(params, { arrayFormat: 'repeat' });
            } }, options);
        return axiosApi(path, mergedOptions).then((resp) => resp.data);
    };
};
const axiosFactory = ({ baseURL, validarRequestSaida = true, utilizarInterceptors = true, customHeaders = {}, }) => {
    const axiosApi = axios_1.default.create({
        baseURL,
    });
    axiosApi.sendRequest = sendRequestFactory(axiosApi);
    if (utilizarInterceptors) {
        interceptors_1.configurarInterceptors({
            axiosApi,
            validarRequestSaida,
            customHeaders,
        });
    }
    return axiosApi;
};
exports.default = axiosFactory;
//# sourceMappingURL=axiosFactory.js.map